import { render } from "./SustainabilityReport2023.vue?vue&type=template&id=05c964f5"
import script from "./SustainabilityReport2023.vue?vue&type=script&lang=js"
export * from "./SustainabilityReport2023.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__